import { render } from "./CFAFooter.vue?vue&type=template&id=5a985a7e&scoped=true"
import script from "./CFAFooter.vue?vue&type=script&lang=js"
export * from "./CFAFooter.vue?vue&type=script&lang=js"

import "./CFAFooter.vue?vue&type=style&index=0&id=5a985a7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a985a7e"]])

export default __exports__